export default __webpack_public_path__ + "static/media/phone-alt-solid.4c5dc241.svg";